import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function surnameDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/surname/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
